/**
 * Mirror of the backend's _resolve_journal_captions / _resolve_caption_template.
 * Returns the effective caption for a slide given its index in the journal.
 */
export function resolveCaption(slide, journal, index) {
  const raw = (slide?.caption || "").trim();
  if (raw) return raw;
  if (!journal?.caption_fallback_enabled) return "";
  const templates = (journal?.caption_templates || []).filter((t) => t && t.trim());
  if (!templates.length) return "";
  const tpl = templates[index % templates.length];
  const vars = { ...(journal?.caption_variables || {}) };
  if (vars.title === undefined) vars.title = journal?.title || "";
  if (vars.company === undefined) vars.company = slide?.company_name || "";
  if (vars.index === undefined) vars.index = String(index + 1);
  if (vars.n === undefined) vars.n = String(index + 1);
  let out = tpl;
  for (const [k, v] of Object.entries(vars)) {
    out = out.split(`{${k}}`).join(v == null ? "" : String(v));
  }
  return out;
}
